var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "form-group registration" },
        [
          _c("pincode", {
            attrs: {
              target: _vm.phone,
              channel: _vm.phoneChannel,
              "channel-target": _vm.currentPhoneTarget,
              "resend-interval": _vm.resendInterval,
              "on-resend": _vm.sendPhoneRequest,
              "start-timer": _vm.setStartTimer,
              "support-button": true,
            },
            on: { pinready: _vm.setPin },
          }),
          _vm._v(" "),
          _c("input", {
            attrs: {
              type: "hidden",
              id: "token",
              name: "token",
              required: "required",
            },
            domProps: { value: _vm.pin },
          }),
          _vm._v(" "),
          _vm.hasError
            ? _c("i18n", {
                staticClass: "text-red",
                attrs: { val: "confirmationFailed" },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("thumbnail2fa", {
            attrs: {
              "is-s-m-s-panel": _vm.isSMSPanel,
              "is-flash-call-panel": _vm.isFlashCallPanel,
              "is-voice-call-panel": _vm.isVoiceCallPanel,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showCallModal
        ? _c("modal2fa", {
            attrs: {
              "is-s-m-s": _vm.isSMS,
              "is-flash-call": _vm.isFlashCall,
              "is-voice-call": _vm.isVoiceCall,
              "close-call-modal": _vm.closeCallModal,
              "send-phone-modal-request": _vm.sendPhoneModalRequest,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }